import React from 'react';
import ReactDOM from 'react-dom';
import Navbar from '../components/Navbar';

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
  const navbarElement = document.getElementById('navbar-root');
  if (navbarElement) {
    ReactDOM.render(<Navbar />, navbarElement);
  }
}, 3);

});
